import { render, staticRenderFns } from "./AddFeedbackModal.vue?vue&type=template&id=7c630b8c&scoped=true"
import script from "./AddFeedbackModal.vue?vue&type=script&lang=js"
export * from "./AddFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./AddFeedbackModal.vue?vue&type=style&index=0&id=7c630b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c630b8c",
  null
  
)

export default component.exports